/**
/* Created by Tengfei Li on 2020/7/7.
 */

export const ru = {
    auth_tip: 'Предоставление {{name}} доступа к устройствам Qingping',
    auth_tip2: 'После авторизации {{name}} получит доступ к управлению устройствами в вашей учетной записи Qingping.',
    google_privacy: 'Просмотреть ',
    google_privacy2: 'Политику конфиденциальности {{name}}',
    confirm_auth: 'Согласиться и авторизовать',
    read_privacy: 'Прочитал и согласен',
    login_tip: 'Вы авторизуете {{name}} на управление вашими устройствами, пожалуйста, сначала войдите в систему.',
    login_tip2: 'Если в вашем аккаунте не добавлен номер телефона или электронная почта, пожалуйста, инициируйте авторизацию в приложении Qingping.',
    input_password_tip: 'Пожалуйста, введите пароль от аккаунта %@.',
    code_sent_tip: 'Код подтверждения отправлен на номер %@, срок действия 10 минут.',
    code_send_tip2: 'Если вы не получили, пожалуйста, проверьте папку со спамом.',
    set_code_fail: 'Не удалось получить код подтверждения.',
    send_code_timeout: 'Повторная отправка через %@ секунд',
    re_send_code: 'Повторно получить код',
    login_fail: 'Ошибка входа.',
    title_input_pwd: 'Введите пароль',
    select_home: 'Выберите страну или регион',
    country_code_placeholder: 'Искать страну или регион',
    welcome: 'Войти',
    phone: 'Номер телефона',
    phone_login: 'Номер телефона',
    email_login: 'Электронная почта',
    email: 'Электронная почта',
    password: 'Пароль',
    code: 'Код подтверждения',
    send: 'Отправить код',
    via_email: 'Войти по почте',
    via_password: 'Войти по паролю',
    via_verify: 'Войти с помощью кода',
    account_or_password_error: 'Неверный логин или пароль.',
    captcha_limit_exceeded: 'Превышено количество попыток.',
    username_or_password_limit_exceeded: 'Превышено количество попыток входа.',
    user_type_error: 'Неверный тип пользователя.',
    login_failed_pwd_error: 'Неверный пароль, пожалуйста, введите снова или используйте вход с кодом подтверждения.',
    login_failed_account_not_exist: 'Аккаунт не существует.',
    verification_to_many: 'Слишком много попыток, попробуйте через 10 минут.',
    verification_code_error: 'Неверный код, пожалуйста, проверьте и попробуйте снова.'
};